import qs from 'qs';

const encodeQueryData = (data) => {
  if (typeof data !== 'object') return '';
  return qs.stringify(data);
};
export default {
  encodeQueryData,
};
